import { atom } from "jotai";
import {
  usersCountQueryAtom,
  activeUsersInPeriodQueryAtom,
  userDesignationsQueryAtom,
  userRolesQueryAtom,
} from "../../services/queries";

export const usersCountState = atom(
  (get) => get(usersCountQueryAtom).data || 0
);

export const activeUsersThisMonthState = (params) =>
  atom((get) => {
    const queryAtom = activeUsersInPeriodQueryAtom({ ...params });

    return get(queryAtom).data ?? 0;
  });

export const userDesignationsState = atom((get) => {
  const userDesignationsAtom = userDesignationsQueryAtom();

  return get(userDesignationsAtom).data ?? [];
});

export const userRolesState = atom((get) => {
  const userRolesAtom = userRolesQueryAtom();

  return get(userRolesAtom).data ?? [];
});
